import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

// Moves its element to the end of <body> while it exists, so an overlay drawn inside a card sits over the
// whole page (the nav, the sticky bars) whatever stacking its card is in (owner 2026-10-12: the tools'
// preview opened large). The element keeps its component's styles; Angular removes it as usual.
@Directive( {
  selector: '[appToBody]',
} )
export class ToBodyDirective implements OnInit, OnDestroy {

  constructor( private host: ElementRef<HTMLElement> ) {
  }

  ngOnInit(): void {
    if ( typeof document !== 'undefined' ) {
      document.body.appendChild( this.host.nativeElement );
    }
  }

  ngOnDestroy(): void {
    this.host.nativeElement.remove();
  }
}
